// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#root[data-v-6eec214c]{border-top:none!important;z-index:7}#root .mega-menu[data-v-6eec214c]{margin-top:0;min-height:612px;width:100%}#root .mega-menu .right[data-v-6eec214c]{background-color:#e2f6ff;padding:32px 12px 32px 32px}#root .mega-menu .left[data-v-6eec214c]{background-color:#f4faff;padding:32px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
